import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { Box, Typography } from "@mui/material";
import { NotificationProps } from "src/types/NotificationProps";
import notifyStyles from "./Notify.module.css";

const NotifyError = ({ header, children }: NotificationProps) => {
  return (
    <Box sx={{ display: "inline" }}>
      <Box className={notifyStyles.notifyHeader}>
        <ErrorOutlineIcon className={notifyStyles.errorIcon} />
        <Typography
          variant="h4"
          className={notifyStyles.errorIcon}
        >
          {header}
        </Typography>
      </Box>
      <Box className={notifyStyles.childrenBox}>{children}</Box>
    </Box>
  );
};

export default NotifyError;
